import React from "react";
import { FaInstagram, FaEnvelope, FaFacebook, FaTwitter } from 'react-icons/fa';
import Logo from "./Logo";
function Footer() {
  return (
    <footer className="text-white py-2 bg-white rounded-lg flex w-full items-center justify-center">
      <div className="container px-4 flex flex-col w-full md:flex-row justify-between items-center">
        
        <Logo />
      
      {/* Copyright */}
      <div className="text-black text-center w-full text-center border-gray-400 pt-2 text-sm">
        <p>© {new Date().getFullYear()} Karishma's Closet.</p>
        <p>All rights reserved.</p> 
      </div>
      
        {/* Social Media and Contact */}
        <div className="flex items-center justify-center  space-x-6">
          <a href="https://www.instagram.com/karishmas_closet/profilecard/?igsh=aGZtdHNyeGRiMXU5" target="_blank" rel="noopener noreferrer">
            <FaInstagram className="text-black text-2xl hover:text-pink-400" />
          </a>
          <a href="mailto:info@yourbrand.com">
            <FaEnvelope className="text-black  text-2xl hover:text-blue-400" />
          </a>
          <a href="https://www.facebook.com/yourbrand" target="_blank" rel="noopener noreferrer">
            <FaFacebook className="text-black  text-2xl hover:text-blue-500" />
          </a>
          <a href="https://www.twitter.com/yourbrand" target="_blank" rel="noopener noreferrer">
            <FaTwitter className="text-black  text-2xl hover:text-blue-300" />
          </a>
        </div>
      
      </div>

    </footer>
  );
}

export default Footer;
